import HttpService from "./HttpService";

export default {
    create(params) {
        return new Promise((resolve, reject) => {
            HttpService.post('tarjeta/crearCliente', params).then((response) => {
                if (response.data.en === 1) {
                    resolve(response.data);
                    return;
                }
                reject(response.data);
            }).catch((error) => reject(error));
        });
    },

    findDataBaseKbus(documento,tipoDocumento,idPais) {
        //const urlDES = "http://209.97.181.190:9091/bus/tarjeta/buscarUsuario";
        const urlPRO = 'https://recursos.kbus.kradac.com/bus/tarjeta/buscarUsuario';
        return new Promise((resolve, reject) => {
            HttpService.post(urlPRO, {
                cedula:documento,
                tipoDocumento: tipoDocumento ? 0:1,
                // tipoDocumento,
                // idPais,
                idPais: idPais ? idPais: 1
            }).then((response) => {
                if (response.data.en === 1) {
                    //if(response.data.data.length) {
                        resolve(response.data);
                    //}
                    return;
                }
                reject(response.data);
            }).catch((error) => reject(error));
        })
    },

    findRegistroCivil(documento) {
        return new Promise((resolve, reject) => {
            HttpService.get(`https://diego.ec/servicios/reg_civil/?key=clippb1fb&ci=${documento}`).then((response) => {
                if (response.error) {
                    reject(response.data);
                    return;
                }
                resolve(response.data);
            }).catch((error) => reject(error));
        });
    }
}
